// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://scrollscan.com/address/0xEB0682d148e874553008730f0686ea89db7DA412
export const TRANSPARENT_PROXY_FACTORY = '0xEB0682d148e874553008730f0686ea89db7DA412';

// https://scrollscan.com/address/0x782559e349b084bB7C07c08404aE6E3436cDAE2E
export const PROXY_ADMIN = '0x782559e349b084bB7C07c08404aE6E3436cDAE2E';

// https://scrollscan.com/address/0xC6f44D0daC966658Db36742f5153bDa0EBbb45ab
export const CREATE_3_FACTORY = '0xC6f44D0daC966658Db36742f5153bDa0EBbb45ab';

// https://scrollscan.com/address/0xCb45E82419baeBCC9bA8b1e5c7858e48A3B26Ea6
export const PROTOCOL_GUARDIAN = '0xCb45E82419baeBCC9bA8b1e5c7858e48A3B26Ea6';

// https://scrollscan.com/address/0xE61Da4C909F7d86797a0D06Db63c34f76c9bCBDC
export const wstETH_stETH_AGGREGATOR = '0xE61Da4C909F7d86797a0D06Db63c34f76c9bCBDC';

// https://scrollscan.com/address/0x22740deBa78d5a0c24C58C740e3715ec29de1bFa
export const AFC_SAFE = '0x22740deBa78d5a0c24C58C740e3715ec29de1bFa';

// https://scrollscan.com/address/0xdef1FA4CEfe67365ba046a7C630D6B885298E210
export const MASIV_SAFE = '0xdef1FA4CEfe67365ba046a7C630D6B885298E210';

// https://scrollscan.com/address/0xa9e777D56C0Ad861f6a03967E080e767ad8D39b6
export const APE_VOTING_SAFE = '0xa9e777D56C0Ad861f6a03967E080e767ad8D39b6';

// https://scrollscan.com/address/0xc50C0D9C4E5df6f2F244a72FD4DA562877CD16EE
export const REWARD_STEWARD = '0xc50C0D9C4E5df6f2F244a72FD4DA562877CD16EE';

export const CHAIN_ID = 534352;
